import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptEure27 = () => {
  return (
    <DepartmentTemplate
      department="Eure"
      departmentNumber="27"
      cities="Évreux, Vernon, Louviers, Bernay"
      region="Normandie"
    />
  );
};

export default DeptEure27;
